import React, { LazyExoticComponent } from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { settingsLoadedSelector, showMetersInTenantAppSelector } from 'environment/redux/environmentReducer';
import { AppState } from 'core/redux/rootReducer';
import { Protected } from './index';

type MetersRouteProps = {
    Component: LazyExoticComponent<React.ComponentType> | React.FC;
};

export function MetersRoute({ Component }: MetersRouteProps): JSX.Element {
    const isLoggedIn = useSelector(({ auth }: AppState) => auth.isLoggedIn);
    const settingsLoaded = useSelector(settingsLoadedSelector);
    const showMetersInTenantApp = useSelector(showMetersInTenantAppSelector);

    if (isLoggedIn && settingsLoaded && showMetersInTenantApp === false) {
        return <Navigate to="/" replace />;
    }

    return <Protected Component={Component} />;
}
